module.exports = "dist/2751ee43015f9884c3642f103b7f70c9.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Regular.woff2
// module id = 212
// module chunks = 0